// GENERATED FILE - DO NOT MODIFY

export enum GetHappeningAttendeesSortColumnDto {
    Name = "Name",
    JobTitle = "JobTitle",
    DefaultOffice = "DefaultOffice",
}